<template>
  <table v-if="rates">
    <tbody>
      <template v-for="[key, rate] of Object.entries(rates)">
        <tr :key="key" v-if="$te(`comparator.offers.offer.ratings.${key}`)">
          <td>{{ $t(`comparator.offers.offer.ratings.${key}`) }} </td>
          <td class="u-white-space-nowrap">
            <Stars :class="[$vClass('stars'), 'u-margin-left-xxsmall']"
                   :note="rate"
                   :note-max="5"/>
          </td>
          <td class="u-white-space-nowrap">
                <span :class="[$vClass('content__rating'),
                 'u-display-block u-margin-left-xxsmall u-text-align-end']">
                  {{ rate }}/5</span>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import Stars from '../../../utils/components/Stars.vue';

export default {
  name: 'OfferRates',
  nameClassStyle: 'offer-rating',
  components: {
    Stars,
  },
  props: {
    rates: Object,
  },
};
</script>

<style lang="scss">
@import '../../../assets/scss/components/OfferRating';
</style>
